export default "__VITE_ASSET__COtFrJvA__"